<template>
  <div></div>
</template>
<script>
export default {


  beforeRouteEnter(to, from, next) {
    console.log(to, from, next)
    next(vm => {
      vm.$router.replace(from.path)
      vm.$message({ message: "刷新成功", type: "success" });
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/page/refresh.vue